import React, { memo } from 'react'
import styled from 'styled-components/macro'
import { ITheme } from 'styles/types'

interface IProps {
  children: React.ReactNode
}

const RegisterLayout: React.FC<IProps> = ({ children }) => {
  return (
    <Screen>
      <Container>{children}</Container>
    </Screen>
  )
}

export default memo(RegisterLayout)

const Screen = styled.div`
  height: 100vh;
  position: relative;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  -webkit-overflow-scrolling: touch;
`

const Container = styled.div`
  width: 370px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.md} {
    width: 300px;
  }

  @media (max-height: 350px) {
    justify-content: flex-start;
    padding-top: 5px;
  }
`
